<script>
const iconMap = {};
const requireSVGs = require.context('../../public/assets/img', false, /\.svg$/);
requireSVGs.keys().forEach((key) => {
  const id = key.replace('./', '').replace('.svg', '');
  iconMap[id] = `icon-${id}`;
});
export default {
  props: {
    name: {
      type: String,
      required: true,
      validate: name => Object.keys(iconMap).includes(name),
    },
  },
  computed: {
    iconId() {
      return iconMap[this.name];
    },
  },
};
</script>

<template>
  <svg class="icon" :class="iconId">
    <use :xlink:href="`#${iconId}`" />
  </svg>
</template>

<style scoped>
  .icon {
    fill: currentColor;
  }
</style>
